<template>
  <div class="row">
    <div class="col-md-4" v-for="job in activeJobs">
      <div class="ibox ibox-job-overview">
        <div class="ibox-title">
          <h5>
            <strong><span class="text-success">Active</span> Job {{ job.number }}</strong> Updated: {{ job.updated_at }}
          </h5>
        </div>
        <div class="ibox-content ibox-content-padding-xs">
          <h2 class="text-primary">{{ job.status_text }}</h2>

          <div class="progress">
            <div
              v-if="job.progressCompletedPercentage > 0"
              :style="{ width: `${job.progressCompletedPercentage}%` }"
              aria-valuemax="100"
              aria-valuemin="0"
              :aria-valuenow="job.progressCompletedPercentage"
              role="progressbar"
              class="progress-bar progress-bar-primary">
              <span class="sr-only">{{ job.progressCompletedPercentage }}% Complete</span>
            </div>
          </div>

          <ul class="details">
            <li><strong>Quantity:</strong> {{ job.quantity }}</li>
            <li><strong>Pickup from:</strong> {{ job.location_from.formattedName }}</li>
            <li><strong>Deliver to:</strong> {{ job.location_to.formattedName }}</li>
          </ul>

        </div>
        <div class="ibox-footer">
          <router-link :to="{ name: 'jobs.show', params: { id: job.id }}">View Job</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { map } from 'lodash'
  import { JobDecorator } from 'decorators'

  export default {
    data () {
      return {
        activeJobs: []
      }
    },

    created () {
      if (this.$user.isClientOrCarrier) {
        this.getJobs({user_id: this.$user.id, status: 'active', commodity: 'all', page_size: 3, sort: 'updated_at'})
          .then((response) => {
            this.activeJobs = map(response.data.data, job => new JobDecorator(job))
          })
      }
    },

    methods: {
      ...mapActions('job', ['getJobs'])
    }
  }
</script>



// WEBPACK FOOTER //
// ActiveJobs.vue?1b3437d0